var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 253 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.365 29.4171L97.436 83.3532L138.163 110.321L173.387 54.1836C173.387 54.1836 189.898 23.8034 174.487 14.5572C160.728 6.30176 140.365 29.4171 140.365 29.4171Z",
    fill: "#01BFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.994 68.4932L97.436 83.3533L138.163 110.321L148.07 94.3606C148.07 94.3606 144.217 80.0509 131.008 72.3459C122.631 67.4593 108.994 68.4932 108.994 68.4932Z",
    fill: "#0BADDA"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 12,
    width: 85,
    height: 99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.365 29.5475L97.436 83.4836L138.163 110.451L173.387 54.314C173.387 54.314 189.898 23.9337 174.487 14.6876C160.728 6.43213 140.365 29.5475 140.365 29.5475Z",
    fill: "#01BFF3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.737 35.6017C165.48 48.8105 133.761 91.7391 133.761 91.7391L138.164 98.8939C138.164 98.8939 160.729 65.3215 172.837 43.3069C178.244 33.4759 180.542 17.4396 180.542 17.4396L178.891 14.6878C178.891 14.6878 177.993 22.3929 171.737 35.6017Z",
    fill: "white",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.163,
    cy: 96.7001,
    rx: 24.4241,
    ry: 16.6156,
    transform: "rotate(35.202 118.163 96.7001)",
    fill: "#6FD3EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.193 54.1836C99.9852 59.278 88.6279 75.6479 88.6279 75.6479C88.6279 75.6479 94.4864 72.8383 98.5345 72.3457C102.086 71.9135 105.829 72.4995 107.273 72.771C107.652 72.8423 108.043 72.7032 108.282 72.4005L124.402 51.9821C124.402 51.9821 117.247 51.4318 111.193 54.1836Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.703 87.7C159.886 99.9842 148.57 116.383 148.57 116.383C148.57 116.383 149.135 109.91 148.169 105.948C147.321 102.472 145.453 99.1755 144.69 97.9201C144.49 97.5905 144.483 97.1758 144.682 96.8454L158.107 74.563C158.107 74.563 161.144 81.0646 160.703 87.7Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 97,
    y: 12,
    width: 85,
    height: 99
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.365 29.5475L97.436 83.4836L138.163 110.451L173.387 54.314C173.387 54.314 189.898 23.9337 174.487 14.6876C160.728 6.43213 140.365 29.5475 140.365 29.5475Z",
    fill: "#01BFF3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.387 18.9601C168.91 15.6025 162.93 15.1076 159.628 14.5572L162.93 8.50317L186.046 11.3854L182.193 30.5178C179.441 26.6653 177.79 22.2623 173.387 18.9601Z",
    fill: "#0BADDA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.981 40.9758C168.981 47.3589 164.661 51.9831 157.974 51.9831C153.021 51.9831 145.315 47.0298 145.866 39.3247C146.28 33.5298 150.736 29.9684 157.424 29.9684C162.927 29.9684 168.981 34.5926 168.981 40.9758Z",
    fill: "#7FDFFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.157,
    y: 38.6645,
    width: 17.8952,
    height: 5.50366,
    transform: "rotate(-23.5353 146.157 38.6645)",
    fill: "#BCF1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.171,
    y: 45.37,
    width: 18.8177,
    height: 3.11806,
    transform: "rotate(-23.5353 149.171 45.37)",
    fill: "#BCF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91 41.5262C166.91 44.4889 165.911 46.9787 164.2 48.7235C162.492 50.4652 160.008 51.5336 156.903 51.5336C154.712 51.5336 151.776 50.4144 149.449 48.3464C147.146 46.2992 145.544 43.4185 145.792 39.9464C145.981 37.3054 147.078 35.2304 148.849 33.8023C150.633 32.3628 153.181 31.5189 156.352 31.5189C161.419 31.5189 166.91 35.8042 166.91 41.5262Z",
    stroke: "#256B8A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.981 40.9758C167.981 43.9384 166.982 46.4282 165.271 48.173C163.563 49.9147 161.079 50.9831 157.974 50.9831C155.783 50.9831 152.847 49.8639 150.52 47.7959C148.217 45.7487 146.615 42.8681 146.863 39.3959C147.052 36.755 148.15 34.6799 149.92 33.2518C151.705 31.8124 154.252 30.9684 157.424 30.9684C162.49 30.9684 167.981 35.2537 167.981 40.9758Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.895,
    cy: 89.2984,
    rx: 7.37108,
    ry: 5.23809,
    transform: "rotate(35.9405 105.895 89.2984)",
    fill: "#B3EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.05 93.3421C112.345 91.1269 110.993 88.4223 108.45 86.5788C105.154 84.1894 101.106 84.1511 99.4079 86.4933C99.3412 86.5852 99.2792 86.6795 99.2217 86.7759C99.309 86.12 99.5407 85.507 99.9286 84.9719C101.627 82.6297 105.675 82.668 108.971 85.0574C112.137 87.353 113.457 90.9836 112.05 93.3421Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.885,
    cy: 91.92,
    rx: 7.37108,
    ry: 5.23809,
    transform: "rotate(35.9405 121.885 91.92)",
    fill: "#B3EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.04 95.964C128.335 93.7488 126.982 91.0443 124.439 89.2007C121.144 86.8113 117.095 86.773 115.397 89.1152C115.33 89.2072 115.268 89.3014 115.211 89.3978C115.298 88.7419 115.53 88.1289 115.918 87.5938C117.616 85.2516 121.664 85.2899 124.96 87.6793C128.127 89.9749 129.447 93.6055 128.04 95.964Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.081,
    cy: 104.028,
    rx: 7.37108,
    ry: 5.23809,
    transform: "rotate(35.9405 113.081 104.028)",
    fill: "#B3EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.236 108.072C119.531 105.857 118.179 103.152 115.636 101.309C112.34 98.9194 108.291 98.8811 106.593 101.223C106.527 101.315 106.465 101.41 106.407 101.506C106.495 100.85 106.726 100.237 107.114 99.7019C108.812 97.3597 112.86 97.398 116.156 99.7874C119.323 102.083 120.643 105.714 119.236 108.072Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.591,
    cy: 106.23,
    rx: 7.37108,
    ry: 5.23809,
    transform: "rotate(35.9405 129.591 106.23)",
    fill: "#B3EEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.745 110.274C136.04 108.058 134.688 105.354 132.145 103.51C128.849 101.121 124.801 101.083 123.103 103.425C123.036 103.517 122.974 103.611 122.917 103.707C123.004 103.052 123.235 102.439 123.623 101.903C125.321 99.5613 129.37 99.5996 132.666 101.989C135.832 104.285 137.152 107.915 135.745 110.274Z",
    fill: "#256B8A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.358 91.8587C97.6042 92.8175 98.5597 107.146 98.5597 107.146C98.8213 111.07 100.085 114.858 101.257 118.372C102.226 121.275 103.132 123.991 103.358 126.44C103.934 132.681 102.134 138.152 98.8884 143.114C97.9478 142.436 97.0248 141.751 96.1177 141.078C94.0515 139.543 92.0682 138.071 90.149 136.898C80.2424 130.844 67.0336 129.193 56.0262 134.696C45.0189 140.2 45.5688 148.455 45.5688 148.455C45.5688 148.455 44.4686 139.65 36.7634 137.999C29.0583 136.347 22.4539 140.75 15.8495 156.711C11.4737 167.286 15.7953 176.411 19.2101 181.365C21.0819 184.081 24.2883 185.352 27.5863 185.392L160.045 186.981C160.045 186.981 164.864 186.443 167.2 183.129C169.684 179.605 168.438 175.791 167.124 171.768C166.177 168.866 165.193 165.854 165.549 162.765C165.871 159.962 167.178 157.906 168.443 155.914C169.953 153.538 171.404 151.254 171.052 147.905C170.491 142.563 166.7 140.397 162.539 138.021C159.753 136.429 156.801 134.743 154.541 131.944C150.396 126.812 148.401 122.011 146.395 117.185C144.453 112.513 142.502 107.817 138.581 102.775C134.729 97.8218 127.573 93.4188 127.573 93.4188C127.573 93.4188 123.935 90.8359 122.62 92.3181C120.419 94.7985 124.272 96.1707 124.272 96.1707C124.272 96.1707 134.069 100.084 137.48 107.728C142.32 118.572 140.639 132.071 133.264 141.053C126.157 136.487 117.61 130.351 112.164 124.239C111.119 123.066 110.132 122.143 109.201 121.273C107.407 119.594 105.825 118.114 104.459 115.433C102.16 110.921 103.461 104.553 104.48 99.5663C105.44 94.8663 106.15 91.3935 103.358 91.8587Z",
    fill: "#ABD8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.457 123.389C111.623 114.932 109.503 107.504 109.503 107.504C109.503 107.504 108.561 98.293 113.846 100.936C114.801 101.413 114.324 104.28 114.324 104.28C114.324 104.28 112.413 111.446 121.49 121.478C126.401 126.906 141.025 126.826 139.226 133.922C138.754 135.785 137.141 136.406 137.025 138.324C136.822 141.676 141.978 143.563 146.381 149.882C153.892 160.663 154.668 168.595 151.334 178.501C145.591 195.564 133.172 196.113 133.172 196.113L51.2166 195.035C50.0898 195.02 48.9469 194.856 48.032 194.198C45.6126 192.458 41.6763 187.486 47.8652 175.199C51.4636 168.055 56.6681 165.292 65.477 164.742C78.1822 163.948 92.9922 178.501 97.3982 171.346C102.388 163.244 87.0176 162.019 88.5893 152.634C90.9254 138.685 111.18 137.53 111.457 123.389Z",
    fill: "#E6F5FC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.317 87.7529C194.771 83.3777 213.332 62.0001 213.332 36.2873C213.332 26.6241 210.711 17.5731 206.14 9.80676C224.905 14.6601 238.765 31.7052 238.765 51.9874C238.765 76.0482 219.26 95.5533 195.2 95.5533C185.949 95.5533 177.371 92.6699 170.317 87.7529Z",
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.1664,
    cy: 6.8526,
    r: 2.75183,
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.948,
    cy: 4.10073,
    r: 1.10073,
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.4748,
    cy: 51.9826,
    r: 1.6511,
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.728,
    cy: 4.10073,
    r: 1.10073,
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6915 31.5823L38.6852 29.1975L37.409 28.1765C37.2547 28.0531 37.3537 27.8046 37.5505 27.821L39.2014 27.9586L39.9932 26.0581C40.0644 25.8874 40.3091 25.8964 40.3676 26.0718L41.0478 28.1125L42.9092 28.2676C43.1001 28.2835 43.1616 28.5328 43 28.6356L41.5333 29.569L42.186 31.527C42.249 31.716 42.0269 31.8709 41.8713 31.7464L40.2056 30.4139L37.9835 31.828C37.8184 31.933 37.6162 31.7629 37.6915 31.5823Z",
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5802 28.8536L96.4048 22.9783L92.5338 20.2944C92.3666 20.1785 92.4592 19.9159 92.6622 19.9306L97.6953 20.2941L99.9879 15.5255C100.064 15.3675 100.292 15.3767 100.355 15.5403L102.311 20.6275L107.771 21.0218C107.969 21.0361 108.027 21.3002 107.853 21.3964L103.525 23.7832L105.459 28.8114C105.53 28.9951 105.32 29.1597 105.158 29.0475L100.206 25.6138L93.857 29.1154C93.6865 29.2094 93.4958 29.0291 93.5802 28.8536Z",
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.886 107.871L225.779 106.113L225.041 104.655C224.952 104.479 225.145 104.293 225.318 104.39L226.763 105.2L228.271 103.798C228.407 103.673 228.626 103.782 228.606 103.966L228.379 106.105L230.009 107.018C230.176 107.112 230.129 107.364 229.939 107.391L228.217 107.632L227.999 109.684C227.978 109.882 227.712 109.931 227.622 109.753L226.659 107.85L224.05 108.216C223.857 108.243 223.743 108.004 223.886 107.871Z",
    fill: "#5E6376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4153 81.6655L47.9962 80.2714L47.3162 79.7274C47.162 79.604 47.2609 79.3555 47.4577 79.3719L48.3403 79.4455L48.7997 78.3428C48.8709 78.1721 49.1156 78.1811 49.1741 78.3565L49.5713 79.548L50.615 79.635C50.8059 79.6509 50.8674 79.9002 50.7058 80.0031L49.8949 80.519L50.2587 81.6102C50.3217 81.7993 50.0996 81.9541 49.944 81.8296L49.0098 81.0823L47.7073 81.9112C47.5422 82.0163 47.34 81.8462 47.4153 81.6655Z",
    fill: "#5E6376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 9.77576,
    width: 195.062,
    height: 211.337,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 23.3335,
    y: 0,
    width: 229.432,
    height: 135.364,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.8a04ea83.svg";
export { ForwardRef as ReactComponent };